import z from 'zod';

import {
  BooleanQuestion,
  CheckboxQuestion,
  CommentQuestion,
  DropdownQuestion,
  MatrixDropdownQuestion,
  MatrixDynamicQuestion,
  MatrixQuestion,
  RadioGroupQuestion,
  RankingQuestion,
  RatingQuestion,
  TagboxQuestion,
  TextQuestion,
} from '../questions';

const QuestionSchema = z.union([
  BooleanQuestion,
  CheckboxQuestion,
  CommentQuestion,
  DropdownQuestion,
  RadioGroupQuestion,
  RankingQuestion,
  RatingQuestion,
  TagboxQuestion,
  TextQuestion,
  MatrixDropdownQuestion,
  MatrixDynamicQuestion,
  MatrixQuestion,
]);

export const AISuggestedQuestion = z.object({
  question: QuestionSchema,
});
